export enum ClientAgentAffiliationTime {
  LESS_THAN_ONE_YEAR = 'LESS_THAN_ONE_YEAR',
  BETWEEN_ONE_AND_THREE_YEARS = 'BETWEEN_ONE_AND_THREE_YEARS',
  BETWEEN_THREE_AND_FIVE_YEARS = 'BETWEEN_THREE_AND_FIVE_YEARS',
  BETWEEN_FIVE_AND_TEN_YEARS = 'BETWEEN_FIVE_AND_TEN_YEARS',
  MORE_THAN_TEN_YEARS = 'MORE_THAN_TEN_YEARS',
}
